import * as Sentry from '@sentry/react';

// import * as serviceWorker from './serviceWorker';

import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { PrismicProvider } from '@prismicio/react';
import { HelmetProvider } from 'react-helmet-async';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import ReactIntlProvider from './components/IntlProvider';
import { client } from './lib/services/prismicService';
import Routes from './routes';
import configureStore from './store/configureStore';
import { default as jaimyTheme } from './theme';
import GlobalStyle from './theme/global';
const queryClient = new QueryClient();

const environment = import.meta.env.VITE_ENV;

Sentry.init({
  enabled: environment !== 'development',
  dsn: import.meta.env.VITE_SENTRY_KEY,
  release: import.meta.env.VITE_RELEASE_NAME,
  integrations: [new Sentry.BrowserTracing()],

  tracesSampleRate: 0,

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,

  environment
});

if (environment && environment !== 'development') {
  const tagManagerArgs = {
    gtmId: import.meta.env.VITE_GTM,
    dataLayerName: 'ProDataLayer',
    events: {
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    }
  };

  TagManager.initialize(tagManagerArgs);
}

const store = configureStore();

const materialTheme = createTheme({
  palette: {
    primary: {
      light: '#cf3369',
      main: '#C30144',
      dark: '#88002f',
      contrastText: '#fff'
    }
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#32546D',
          fontFamily: "'Lato', sans-serif",
          fontWeight: 'bold',
          fontSize: '16px',
          '&.Mui-focused': {
            color: '#32546D'
          }
        }
      }
    }
  }
});
const root = createRoot(document.getElementById('root')!);
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={jaimyTheme}>
          <MuiThemeProvider theme={materialTheme}>
            <CssBaseline />
            <ReactIntlProvider>
              <PersistGate persistor={store.__persistor} loading={null}>
                <PrismicProvider client={client}>
                  <QueryClientProvider client={queryClient}>
                    <Routes />
                    <noscript>
                      <iframe
                        title="GTM No Script"
                        src={`"https://www.googletagmanager.com/ns.html?id=${import.meta.env.VITE_GTM}"`}
                        height="0"
                        width="0"
                        style={{ display: 'none', visibility: 'hidden' }}
                      />
                    </noscript>
                  </QueryClientProvider>
                </PrismicProvider>
              </PersistGate>
            </ReactIntlProvider>
          </MuiThemeProvider>
          <GlobalStyle />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);
